module.exports = __webpack_public_path__ + "img/help_appbar.d31b2177.png";